import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import GraphicsItem from "./GraphicsItem";
import {
  Wrapper,
  Header,
  Body,
  Row,
  Column,
  Number,
  Description,
} from "./styles/agency-income-metrics-styles";

interface IAgencyIncomeMetricsProps {
  loading: boolean;
  netRecruiterPlacementFee: {
    totalFee?: number;
  };
  currency: CurrencyResource;
}

export const AgencyIncomeMetrics: FunctionComponent<
  IAgencyIncomeMetricsProps
> = ({ loading, netRecruiterPlacementFee, currency }) => (
  <Wrapper>
    {loading && <WidgetLoading zIndex={1} />}
    <Header className="panel-heading">
      <div className="panel-title">Your Fees</div>
    </Header>
    <Body>
      <Row>
        <Column flex={1}>
          <Number fontSize="large" data-test-id="total-placement-fee">
            {`${currency.symbol}${netRecruiterPlacementFee.totalFee}`}
          </Number>
          <Description data-test-id="income-metrics">
            Placement income to date
          </Description>
        </Column>
        <Column flex={1}>
          <GraphicsItem income={netRecruiterPlacementFee.totalFee} />
        </Column>
      </Row>
    </Body>
  </Wrapper>
);

AgencyIncomeMetrics.propTypes = {
  loading: PropTypes.bool.isRequired,
  netRecruiterPlacementFee: PropTypes.shape({
    totalFee: PropTypes.number,
  }),
  currency: PropTypes.shape({
    symbol: PropTypes.string,
    isoCode: PropTypes.string,
  }),
};

AgencyIncomeMetrics.defaultProps = {
  netRecruiterPlacementFee: {
    totalFee: 0,
  },
  currency: {
    symbol: "",
  },
};

interface IReduxState {
  dashboard: {
    loading: boolean;
    recruiter: {
      netRecruiterPlacementFee: {
        totalFee?: number;
      };
      currency: CurrencyResource;
    };
  };
}

interface CurrencyResource {
  symbol?: string;
  isoCode?: string;
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.dashboard.loading,
  currency: state.dashboard.recruiter.currency,
  netRecruiterPlacementFee: state.dashboard.recruiter.netRecruiterPlacementFee,
});

export default connect(mapStateToProps, {})(AgencyIncomeMetrics);
